import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Importare traduceri
import roCommon from '../locales/ro/common.json'
import roAuth from '../locales/ro/auth.json'
import roOffers from '../locales/ro/offers.json'
import roPartners from '../locales/ro/partners.json'
import roAdmin from '../locales/ro/admin.json'

import enCommon from '../locales/en/common.json'
import enAuth from '../locales/en/auth.json'
import enOffers from '../locales/en/offers.json'
import enPartners from '../locales/en/partners.json'
import enAdmin from '../locales/en/admin.json'

// Resurse traduceri
const resources = {
  ro: {
    common: roCommon,
    auth: roAuth,
    offers: roOffers,
    partners: roPartners,
    admin: roAdmin,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    offers: enOffers,
    partners: enPartners,
    admin: enAdmin,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ro', // Limba implicită: Română
    fallbackLng: 'ro',
    defaultNS: 'common',
    ns: ['common', 'auth', 'offers', 'partners', 'admin'],

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'suuper-lang',
    },

    interpolation: {
      escapeValue: false, // React face deja escape
    },

    react: {
      useSuspense: true,
    },
  })

export default i18n

// Funcție helper pentru schimbarea limbii
export const changeLanguage = (lang: 'ro' | 'en') => {
  i18n.changeLanguage(lang)
  localStorage.setItem('suuper-lang', lang)
}

// Funcție helper pentru limba curentă
export const getCurrentLanguage = (): 'ro' | 'en' => {
  return (i18n.language || 'ro') as 'ro' | 'en'
}
